export const PLUGIN_KEY = "plugin-s3";
export const LUCID_VERSION = "0.x.x";

export const PRESIGNED_URL_EXPIRY = 3600; // 1 hour
